import { Formik } from "formik";
import { useContext, useEffect } from "react";
import { newQuotation } from "../../../../api/quotationApiClient";
import FocusError from "../../../../components/FocusError";
import { ParametrizedField } from "../../../../components/ParametrizedField";
import { StepControls } from "../../../../components/Scenario/Step/StepControls";
import { ProcessingContext } from "../../../../contexts/ProcessingContext";
import { QuotationCardContext } from "../../../../contexts/QuotationCardContext";
import { QuotationContext } from "../../../../contexts/QuotationContext";
import { DurationConvertMap } from "../../../../model/contract";
import { MtplQuotation } from "../../../../model/quotation";
import { getOwnerBirthYearOptions, VehicleType } from "../../../../model/vehicle";
import { strings } from "../../../../strings/strings";
import { useHotjar } from "../../../../utils/hooks/useHotjar";
import * as log from "../../../../utils/log";
import { LogFunctionalModule } from "../../../../utils/log";
import { fieldName } from "./consts";
import "./GreenTarifficationInputViewStyles.scss";

interface GreenTarifficationInputViewProps {
    onSubmit: (MtplQuotation) => void;
    vehicleTypes?: VehicleType[];
    onBackListener: () => void;
}

export const GreenTarifficationInputView = ({
    onSubmit,
    onBackListener,
}: GreenTarifficationInputViewProps) => {
    const { quotation, setQuotation, saveTempValues, type } =
        useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const { loadFromServer, validateFields, nextIsAvailable } = useContext(QuotationCardContext);
    const { setProcessingOpen } = useContext(ProcessingContext);

    const { trackHotjar } = useHotjar();

    useEffect(() => {
        console.log("Google Analytics Event = " + "green_card_calculating");
        // @ts-ignore
        window.dataLayer.push({ event: "green_card_calculating" });

        trackHotjar("data", type);
    }, []);

    useEffect(() => {
        loadFromServer(Object.values(fieldName));
    }, []);

    useEffect(() => {
        if (quotation?.mtplContract) {
            const quotationCopy = { ...quotation };
            // @ts-ignore
            quotationCopy.mtplContract.duration =
                DurationConvertMap[quotation.mtplContract.duration] ||
                quotation.mtplContract.duration;
            if (quotation.mtplContract.duration != quotationCopy.mtplContract.duration) {
                setQuotation(newQuotation);
            }
        }
    }, [quotation]);

    function convertContextNameFunction(name: string) {
        return name.replaceAll("-", ".").replaceAll("Party", "");
    }

    const getOnBack = (formProps) => () => {
        log.sendLog(
            new Date(),
            LogFunctionalModule.STORE_GREEN_CARD,
            "INFO",
            "PERSONAL_INFO_FORM_BACK_HANDLER",
            [{ quotation, formProps }],
        );
        onBackListener();
    };

    const onNext = (values) => {
        setProcessingOpen(true);
        log.sendLog(
            new Date(),
            LogFunctionalModule.STORE_GREEN_CARD,
            "INFO",
            "TARIFICATION_FORM_NEXT_HANDLER",
            [{ quotation, values }],
        );
        validateFields(values.quotation).then((res) => {
            if (res) {
                onSubmit(values.quotation);
            } else {
                setProcessingOpen(false);
            }
        });
    };

    return (
        <Formik initialValues={{ quotation }} onSubmit={onNext}>
            {(formProps) => (
                <div className={"green-tariffication-input"}>
                    {saveTempValues("quotation", JSON.stringify(formProps.values.quotation))}
                    <form id={"mainForm"}>
                        <FocusError />
                        <div className={"green-tariffication-input__form"}>
                            <div className={"green-tariffication-input__form__group"}></div>

                            <div className={"green-tariffication-input__form__inputs"}>
                                <div className={"green-tariffication-input__form__inputs__title"}>
                                    {strings.tarifficationTitle}
                                </div>

                                <div className={"green-tariffication-input__form__inputs__long"}>
                                    <ParametrizedField
                                        contextName={fieldName.coverageTerritory}
                                        quotationName={"quotation.mtplContract."}
                                        selectOneRadio={true}
                                        context={QuotationCardContext}
                                        convertContextNameFunction={convertContextNameFunction}
                                    />
                                </div>
                                <ParametrizedField
                                    contextName={fieldName.vehicleType}
                                    quotationName={"quotation.mtplContract."}
                                    context={QuotationCardContext}
                                    defaultLabel={strings.categoryLong}
                                    convertContextNameFunction={convertContextNameFunction}
                                />
                                <ParametrizedField
                                    contextName={fieldName.duration}
                                    quotationName={"quotation.mtplContract."}
                                    context={QuotationCardContext}
                                    convertContextNameFunction={convertContextNameFunction}
                                />
                                <ParametrizedField
                                    contextName={fieldName.startDate}
                                    quotationName={"quotation.mtplContract."}
                                    context={QuotationCardContext}
                                    convertContextNameFunction={convertContextNameFunction}
                                />
                                <ParametrizedField
                                    contextName={fieldName.vehicleOwnerPartyType}
                                    quotationName={"quotation.mtplContract."}
                                    context={QuotationCardContext}
                                />
                                <ParametrizedField
                                    contextName={fieldName.vehicleOwnerBirthYear}
                                    quotationName={"quotation.mtplContract."}
                                    context={QuotationCardContext}
                                    numericSelectOptions={getOwnerBirthYearOptions}
                                />
                                <ParametrizedField
                                    contextName={fieldName.vehicleTotalWeight}
                                    quotationName={"quotation.mtplContract."}
                                    context={QuotationCardContext}
                                    convertContextNameFunction={convertContextNameFunction}
                                />
                            </div>

                            <StepControls
                                onNext={() => formProps.handleSubmit()}
                                onBack={getOnBack(formProps)}
                                nextIsAvailable={nextIsAvailable}
                                nextStepLabel={strings.calculate}
                            />
                        </div>
                    </form>
                </div>
            )}
        </Formik>
    );
};
